import React from 'react'
import RecordPic from "../../img/img-5.png";

function Record() {
    return (
        <section className="text-[#244566] bg-[#e9eef4] flex flex-col justify-center items-center space-y-14 pt-6 pb-14">
          <h3 className="text-2xl font-semibold">OUR TRACK RECORD</h3>
          <img alt="" src={RecordPic} />
        </section>
      )
}

export default Record